var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('span',{class:{'double': _vm.double}},[_vm._v("\n  "+_vm._s(_vm.value)+_vm._s(_vm.extension)+"\n")]):_c('span',{class:{'double': _vm.double}},[_vm._v("-")])}
var staticRenderFns = []

export { render, staticRenderFns }